import { createContext } from "react";

import SessionManager from "./components/SessionManager";

export const AuthContext = createContext({
  token: null,
  logout: () => {},
});

export const AuthProvider = ({ children }) => {
  const token = localStorage.getItem("sso_token");

  const logout = async () => {
    // stop any ongoing optics session
    const storedSessionId = localStorage.getItem("optics_current_session_id");
    const deviceId = localStorage.getItem("optics_current_device_id");

    try {
      if (storedSessionId && deviceId) {
        await stopOpticsSession(deviceId, storedSessionId);
      }
    } catch (err) {
      console.error(
        `Stop Optics Session API Failed for device ${deviceId}, sessionId ${storedSessionId} with error: `,
        err
      );
    }

    localStorage.clear();

    const logoutUrl = new URL('/logout', process.env.REACT_APP_SSO_PORTAL_URL);
    logoutUrl.searchParams.set('redirect', window.location.href);
    window.location.href = logoutUrl.href;
  };

  return (
    <AuthContext.Provider value={{ token, logout }}>
      <SessionManager />
      {children}
    </AuthContext.Provider>
  );
};
